import {DevelopersListDynamic} from "../src/developers/DevelopersListDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "developers-list", view: <DevelopersListDynamic />}];

(() => prepareHydratedApp(config))();
